import PropTypes from 'prop-types';

// Hard ceiling so the spinner can never balloon to the full window if a global
// or parent style ends up overriding the width/height presentation attributes.
// Inline styles win over both CSS classes and SVG geometry attributes.
const MAX_SIZE = 200;

const LoadingSpinner = (props) => {
  const { color, speed, width, style, ...restOfProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={width}
      height={width}
      style={{
        // Pin the requested size via inline style (authoritative over classes
        // and geometry attributes) and cap it so it can never fill the window.
        width,
        height: width,
        maxWidth: MAX_SIZE,
        maxHeight: MAX_SIZE,
        ...style,
      }}
      {...restOfProps}
    >
      <path
        opacity=".25"
        d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"
        fill={color}
      />
      <path d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z" fill={color}>
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 16 16"
          to="360 16 16"
          dur={speed}
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
};

LoadingSpinner.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  speed: PropTypes.string,
  style: PropTypes.object,
};

LoadingSpinner.defaultProps = {
  color: undefined,
  width: '32px',
  speed: '0.8s',
};

export default LoadingSpinner;
